import { render } from "./ApprovalReturnRequestBySn.vue?vue&type=template&id=f7f88f42&scoped=true"
import script from "./ApprovalReturnRequestBySn.vue?vue&type=script&lang=js"
export * from "./ApprovalReturnRequestBySn.vue?vue&type=script&lang=js"

import "./ApprovalReturnRequestBySn.vue?vue&type=style&index=0&id=f7f88f42&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f88f42"]])

export default __exports__